"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleSystemSize = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const usePrevious_1 = require("../../hooks/usePrevious");
const selectors_1 = require("./selectors");
const slice_1 = require("./slice");
// if the number of outcomes changes in basket, we set the first value of combinations or INITIAL_SYSTEM_SIZE as the current system size
const useHandleSystemSize = () => {
    const countSystemCombinations = (0, react_redux_1.useSelector)(selectors_1.selectCountSystemCombinations);
    const dispatch = (0, react_redux_1.useDispatch)();
    const prevSystemCombinationsLength = (0, usePrevious_1.usePrevious)(countSystemCombinations);
    (0, react_1.useEffect)(() => {
        var _a;
        if (prevSystemCombinationsLength &&
            prevSystemCombinationsLength !== countSystemCombinations) {
            dispatch(slice_1.basketProviderActions.setSystemSize(((_a = countSystemCombinations[0]) === null || _a === void 0 ? void 0 : _a.value) || slice_1.INITIAL_SYSTEM_SIZE));
        }
    }, [prevSystemCombinationsLength, dispatch, countSystemCombinations]);
};
exports.useHandleSystemSize = useHandleSystemSize;
//# sourceMappingURL=useHandleSystemSize.js.map